export default "__VITE_ASSET__Dm$y9PH3__"